import templateUrl from "./user-security-permissions-editor.component.html";

export const UserSecurityPermissionsEditorComponent = {
    templateUrl,
    bindings: {
        user: "<",
        claimPermissions: "<",
        userPermissions: "<",
        addUserPermission: "&onAddUserPermission",
        removeUserPermission: "&onRemoveUserPermission",
        changeUserPermission: "&onChangeUserPermission"
    }
}
